import React, { FC } from "react";
import { StyledValueContainer, StyledValueLine } from "./index.styled";
import { BrandConfigCustomizationsAccountValueprops } from "../../../../types/graphql/generated";

interface SignupValuePropsProps {
  valueProps: BrandConfigCustomizationsAccountValueprops[];
}

export const SignupValueProps: FC<SignupValuePropsProps> = ({ valueProps }) => {
  return (
    <StyledValueContainer>
      {valueProps.map(({ imgUrl, text }, i) => {
        const alt = imgUrl?.substring(imgUrl.lastIndexOf("/") + 1);

        return (
          <StyledValueLine key={i}>
            {imgUrl && <img alt={alt} src={imgUrl} />}
            <span>{text}</span>
          </StyledValueLine>
        );
      })}
    </StyledValueContainer>
  );
};
